export const APPROVAL_STATUS = {
    APPROVED: 'APPROVED',
    AWAITING_APPROVAL: 'AWAITING APPROVAL',
    REJECTED: 'REJECTED',
}